<template>
  <v-select
    class="small-text-field"
    :required="required"
    :value="loyaltyTier"
    :label="label"
    :items="loyaltyTiersFiltered"
    :v-model="loyaltyTier"
    item-value="id"
    item-name="name"
    @input="updateSelf"
    flat
    :hide-details="valid() == true && (error == null || error.length == 0)"
    :error-messages="valid() == true ? null : [valid()]"
    style="width: 120px;"
  >
    <template v-slot:selection="{ item, index }">
      <span style="font-size: 12px !important" v-html="item.name"></span>
    </template>
    <template v-slot:item="{ item, index }">
      <span style="font-size: 12px !important" v-html="item.name"></span>
    </template>
  </v-select>
</template>

<script>
export default {
  name: "SelectableLoyaltyTierInput",
  model: {
    prop: "rideType",
    event: "input"
  },
  props: {
    label: String,
    errorMessages: Object,
    required: { type: Boolean, default: true },
    loyaltyTier: Number,
    loyaltyTiers: Array,
    error: String
  },
  computed: {
    loyaltyTiersFiltered: function() {
      return this.loyaltyTiers.filter(function(f) {
        return f.enabled == true;
      });
    }
  },
  data() {
    return {
      menu: false
    };
  },
  methods: {
    valid() {
      // console.log(this.error);

      if (this.error == null) {
        return true;
      }

      return this.error;
    },
    updateSelf(loyaltyTier) {
      console.log(loyaltyTier);
      this.$emit("input", loyaltyTier);
    },
    focused() {
      console.log("focused");
      this.$emit("focused");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
